import { render, staticRenderFns } from "./PreencherContratoOriginacao.vue?vue&type=template&id=ada81256&lang=pug"
import script from "./PreencherContratoOriginacao.vue?vue&type=script&lang=js"
export * from "./PreencherContratoOriginacao.vue?vue&type=script&lang=js"
import style0 from "./PreencherContratoOriginacao.vue?vue&type=style&index=0&id=ada81256&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports